import React, { useState, useEffect, useRef } from "react";
import Modal from 'react-modal'; // npm install react-modal
import DropdownSelect from "./DropdownSelect";
import AdvanceSearch from "./AdvanceSearch";
import { useSnackbar } from "notistack";
import {
  fnGetFilteredPropertiesUsingLocation,
  fnGetFilteredpropertiesUsingKeyword,
  fnGetFilteredPropertiesusingLocationName,
  fnGetConsolidateandUniqueProperties,
  fnGetFilteredPropertiesonStatusSaleorRent,
  fnGetFilteredPropertiesUsingBedRoom,
  fnGetFilteredPropertiesUsingBathRoom,
  fnGetFilteredPropertiesUsingAreaRange,
  fnGetFilteredPropertiesUsingPriceRange,
  fnGetFilteredPropertiesUsingPropertyType,
  fnGetFilteredPropertiesUsingConstructionStatus,
  fnGetFilteredPropertiesUsingPropertyCategory,
  FullScreenLoader
} from "../../APIs/APIHelperforWeb";
import { PageURLMaster } from "../../APIs/APIUrls";
import { useNavigate } from "react-router-dom";
import LocationModal from "../modals/LocationSearch";
import KeywordSearch from "../modals/KeywordSearch";

export default function FilterTab2({
  tabClass = "nav-tab-form style-1 justify-content-center",
  styleClass = "",
  setLocationName,
  LocationName
}) {

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [isFiltering, setIsFiltering] = useState(false);

  const [CurrentLongitude, setCurrentLongitude] = React.useState(null);
  const [CurrentLatitude, setCurrentLatitude] = React.useState(null);

  const [AdvanceFilteredData, setAdvanceFilteredData] = React.useState([]);
  const [propertyTypelst, setpropertyTypelst] = React.useState([]);
  const [ConstructionStatuslst, setConstructionStatuslst] = React.useState([]);
  const [PropertyCategorylst, setPropertyCategorylst] = React.useState([]);

  const [PropertyStatus, setPropertyStatus] = React.useState("");
  const [PropertyLabel, setPropertyLabel] = React.useState("");
  const [PropertyType, setPropertyType] = React.useState("All");
  const [PropertyCategory, setPropertyCategory] = React.useState("All");
  const [ProjectType, setProjectType] = React.useState("All");
  const [LocationWord, setLocationWord] = React.useState("");
  const [Keyword, setKeyword] = React.useState("");
  const [ConstructionStatus, setConstructionStatus] = React.useState("All");
  const [PriceRange, setPriceRange] = React.useState([100000, 1000000]);
  const [AreaRange, setAreaRange] = React.useState([80, 1000]);
  const [Bedroom, setBedroom] = React.useState(0);
  const [Bathroom, setBathroom] = React.useState(0);
  const [Amenities, setAmenities] = React.useState([]);
  const [pageUrlMasterData, setPageUrlMasterData] = React.useState([]);


  const timerRef = useRef(null);
  const locationtimerRef = useRef(null);
  const AreaRangeRef = useRef(null);
  const PriceRangeRef = useRef(null);

  const ddContainer = useRef();
  const advanceBtnRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click is outside the dropdown and the button
      if (
        ddContainer.current &&
        !ddContainer.current.contains(event.target) &&
        advanceBtnRef.current &&
        !advanceBtnRef.current.contains(event.target)
      ) {
        ddContainer.current?.classList.remove("show");
      }
    };
    AllPropertyTypes();
    getAllConstuctionStatus();
    getAllPropertyCategory();

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, []);

  useEffect(() => {
    const fetchAllPageUrlMasterForWeb = async () => {
      try {
        const response = await fetch(`${PageURLMaster}GetAllPageURLMasterforWeb`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        const rows = result?.data || result?.Data || [];
        setPageUrlMasterData(Array.isArray(rows) ? rows : []);
      } catch (error) {
        console.error('GetAllPageURLMasterforWeb error:', error);
      }
    };

    fetchAllPageUrlMasterForWeb();
  }, []);

  const normalizeText = (value) => (value || '').toString().trim().toLowerCase();
  const normalizeForCompare = (value) =>
    normalizeText(value)
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const resolvePageUrlPath = (rawUrl) => {
    const url = (rawUrl || '').toString().trim();
    if (!url) return '';

    // Absolute URL from API
    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    // Relative/slug URL from API
    return url.startsWith('/') ? url : `/${url}`;
  };


  const AllPropertyTypes = () => {
    const propertyTypes = JSON.parse(localStorage.getItem('AllPropertyTypesforWeb'));
    if (propertyTypes && Array.isArray(propertyTypes) && propertyTypes.length > 0) {
      const mapData = propertyTypes.map(item => item.TypeName);
      const filterdata = mapData.filter(item => item !== "New Projects | Residential" && item !== "New Projects | Commercial");
      filterdata.push("New Project")
      filterdata.shift();
      filterdata.unshift("All");
      setpropertyTypelst(filterdata);
      return filterdata;
    }
  }

  const getAllConstuctionStatus = () => {

    const constructionStatus = JSON.parse(localStorage.getItem('SZTypeListforWeb'));
    if (constructionStatus && Array.isArray(constructionStatus) && constructionStatus.length > 0) {
      const mapData = constructionStatus.filter(item => item.SectionId == 6).map(item => item.TypeName);
      mapData.unshift("All");
      setConstructionStatuslst(mapData);
      return mapData;
    }
  }

  const getAllPropertyCategory = () => {
    const propertyCategory = JSON.parse(localStorage.getItem('ZSectionsList'));
    if (propertyCategory && Array.isArray(propertyCategory) && propertyCategory.length > 0) {
      const mapData = propertyCategory.filter(item => item.SectionId == 11 || item.SectionId == 12).map(item => item.SectionName);
      mapData.unshift("All");
      setPropertyCategorylst(mapData);
      return mapData;
    }
  }

  const getFinalFilteredData = async () => {


    let finalData = [];

    const locationValue = normalizeForCompare(selectedLocation);
    const propertyTypeValue = normalizeForCompare(selectedLocationKeyword);
    const statusValue = normalizeText(PropertyStatus);

    let rows = pageUrlMasterData;

    // Fallback: fetch again at click time if not loaded yet
    if (!Array.isArray(rows) || rows.length === 0) {
      try {
        const response = await fetch(`${PageURLMaster}GetAllPageURLMasterforWeb`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          const result = await response.json();
          rows = result?.data || result?.Data || [];
          rows = Array.isArray(rows) ? rows : [];
          setPageUrlMasterData(rows);
        }
      } catch (error) {
        console.error('GetAllPageURLMasterforWeb click-fetch error:', error);
      }
    }

    if (rows.length > 0 && locationValue && propertyTypeValue) {

      const activeRows = rows.filter((item) => item?.IsActive === true);

      const cityAndTypeRows = activeRows.filter((item) => locationValue === normalizeForCompare(item?.City) && propertyTypeValue === normalizeForCompare(item?.PropertyTypeName));


      const statusMatchedRows = cityAndTypeRows.filter((item) => {
        if (!statusValue) return true;

        const pageUrl = normalizeText(item?.PageURL || item?.PageUrl || item?.pageURL);
        const pageTitle = normalizeText(item?.PageTitle);
        const haystack = `${pageUrl} ${pageTitle}`;

        if (statusValue === 'sale') {
          return haystack.includes('for-sale') || haystack.includes('sale');
        }

        if (statusValue === 'rent') {
          return haystack.includes('for-rent') || haystack.includes('rent');
        }

        return true;
      });

      const matchedRow = statusMatchedRows[0] || cityAndTypeRows[0];

      const pageUrl = resolvePageUrlPath(matchedRow?.PageURL || matchedRow?.PageUrl || matchedRow?.pageURL);


      if (pageUrl) {
        if (/^https?:\/\//i.test(pageUrl)) {
          window.location.href = pageUrl;
        } else {
          navigate(pageUrl);
        }
        return;
      }
      else {
        enqueueSnackbar("No matching properties found for the selected location and property type.", { variant: "info" });
      }
    }
  }

  //Modal Assets

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState('');

  const [modalOpenKeyword, setModalOpenKeyword] = useState(false);
  const [selectedLocationKeyword, setSelectedLocationKeyword] = useState('');

  useEffect(() => {
    if (selectedLocation && selectedLocationKeyword) {
      getFinalFilteredData();
    }
  }, [selectedLocation, selectedLocationKeyword])


  return (
    <div className="flat-tab flat-tab-form">
      <ul className={tabClass} role="tablist">
        <li className="nav-tab-item" role="presentation">
          <a
            onClick={() => setPropertyStatus("Rent")}
            className="nav-link-item active"
            data-bs-toggle="tab"
          >
          Rent
          </a>
        </li>
        <li className="nav-tab-item" role="presentation">
          <a onClick={() => setPropertyStatus("Sell")} className="nav-link-item" data-bs-toggle="tab">
          Sale
          </a>
        </li>
        <li className="nav-tab-item" role="presentation">
          <a onClick={() => setPropertyStatus("PG")} className="nav-link-item" data-bs-toggle="tab">
            PG
          </a>
        </li>
      </ul>
      <div className="tab-content">
        <div className="tab-pane fade active show" role="tabpanel">
          <div className="form-sl">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className={`wd-find-select ${styleClass}`}>
                <div className="inner-group">
                  {/* <div className="form-group-1 search-form form-style">
                    <label>Type</label>
                    <div className="group-select">
                      <DropdownSelect
                        options={propertyTypelst}
                        setValue={setPropertyType}
                      />
                    </div>
                  </div> */}
                  <div className="form-group-2 form-style">
                    <label>Location</label>
                    <div className="group-ip">
                      <input
                        type="text"
                        className="form-control"
                        value={selectedLocation}
                        onClick={() => setModalOpen(true)}
                        readOnly
                        placeholder="Search by location"
                      />
                      <LocationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} onSelect={setSelectedLocation} setLocationName={setLocationName} />
                      <a className="icon icon-location"
                        onClick={() => {
                          setModalOpen(true)
                        }}
                      >
                        {" "}
                      </a>
                    </div>
                  </div>
                  <div className="form-group-3 form-style">
                    <label>Property Type</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search Keyword"
                      defaultValue=""
                      name="s"
                      value={selectedLocationKeyword}
                      onClick={() => setModalOpenKeyword(true)}
                    />
                    <KeywordSearch isOpen={modalOpenKeyword} onClose={() => setModalOpenKeyword(false)} onSelect={setSelectedLocationKeyword} LocationName={LocationName} />
                  </div>
                </div>
                <div className="box-btn-advanced">
                  {/* <div className="form-group-4 box-filter">
                    <a
                      onClick={() =>
                        ddContainer.current.classList.toggle("show")
                      }
                      ref={advanceBtnRef}
                      className="tf-btn btn-line filter-advanced pull-right"
                    >
                      <span className="text-1">Search advanced</span>
                      <svg
                        width={22}
                        height={22}
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 12.375V3.4375M5.5 12.375C5.86467 12.375 6.21441 12.5199 6.47227 12.7777C6.73013 13.0356 6.875 13.3853 6.875 13.75C6.875 14.1147 6.73013 14.4644 6.47227 14.7223C6.21441 14.9801 5.86467 15.125 5.5 15.125M5.5 12.375C5.13533 12.375 4.78559 12.5199 4.52773 12.7777C4.26987 13.0356 4.125 13.3853 4.125 13.75C4.125 14.1147 4.26987 14.4644 4.52773 14.7223C4.78559 14.9801 5.13533 15.125 5.5 15.125M5.5 15.125V18.5625M16.5 12.375V3.4375M16.5 12.375C16.8647 12.375 17.2144 12.5199 17.4723 12.7777C17.7301 13.0356 17.875 13.3853 17.875 13.75C17.875 14.1147 17.7301 14.4644 17.4723 14.7223C17.2144 14.9801 16.8647 15.125 16.5 15.125M16.5 12.375C16.1353 12.375 15.7856 12.5199 15.5277 12.7777C15.2699 13.0356 15.125 13.3853 15.125 13.75C15.125 14.1147 15.2699 14.4644 15.5277 14.7223C15.7856 14.9801 16.1353 15.125 16.5 15.125M16.5 15.125V18.5625M11 6.875V3.4375M11 6.875C11.3647 6.875 11.7144 7.01987 11.9723 7.27773C12.2301 7.53559 12.375 7.88533 12.375 8.25C12.375 8.61467 12.2301 8.96441 11.9723 9.22227C11.7144 9.48013 11.3647 9.625 11 9.625M11 6.875C10.6353 6.875 10.2856 7.01987 10.0277 7.27773C9.76987 7.53559 9.625 7.88533 9.625 8.25C9.625 8.61467 9.76987 8.96441 10.0277 9.22227C10.2856 9.48013 10.6353 9.625 11 9.625M11 9.625V18.5625"
                          stroke="#161E2D"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div> */}
                  <button
                    type="submit"
                    className="tf-btn btn-search primary"
                    onClick={() => getFinalFilteredData()}
                  >
                    Search <i className="icon icon-search" />
                  </button>
                </div>
              </div>
              <div ref={ddContainer} className="wd-search-form">
                <AdvanceSearch
                  PriceRange={PriceRange}
                  setPriceRange={setPriceRange}
                  AreaRange={AreaRange}
                  setAreaRange={setAreaRange}
                  Bedroom={Bedroom}
                  setBedroom={setBedroom}
                  Bathroom={Bathroom}
                  setBathroom={setBathroom}
                  Amenities={Amenities}
                  setAmenities={setAmenities}
                  setConstructionStatus={setConstructionStatus}
                  ConstructionStatuslst={ConstructionStatuslst}
                  setPropertyCategory={setPropertyCategory}
                  PropertyCategorylst={PropertyCategorylst}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      <FullScreenLoader isLoading={isFiltering} />
    </div>

  );
}
